import api from './api';
import { default as config } from '../utilities/config';

class Endpoint {
  constructor(path, request, receive, server = 'metalMastodon') {
    this.server = config.serverUrl[server];
    this.path = path;
    this.request = request;
    this.receive = receive;
    this.method = 'GET';

    if (this.path[0] === '/') {
      this.path = this.path.substring(1);
    }
  }

  withMethod(method) {
    this.method = method;
    return this;
  }

  withBody(body) {
    this.body = body;
    return this;
  }

  withOptions(options) {
    this.debugSleep = options.debugSleep;
    this.onError = options.onError;
    this.ignoreErrors = options.ignoreErrors;
    this.callback = options.callback;
    this.download = options.download;
    this.cToken = options.cToken;
    return this;
  }

  sleep(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  call() {
    const url = `${this.server}${this.path}`;
    if (this.server && this.path && this.request && this.receive) {
      return dispatch => {
        dispatch(this.request());
        return this.sleep(this.debugSleep || 0)
          .then(() => {
            return api(
              dispatch,
              url,
              this.method,
              this.body,
              this.receive,
              this.onError,
              this.ignoreErrors,
              this.callback,
              this.download,
              this.cToken
            );
          })
          .catch(err => {
            console.warn(err.toString());
          });
      };
    }
    console.warn('Missing path, server, request or receive');
    return null;
  }
}

export default Endpoint;
